import Loader from '../../components/standartComponents/loader'
import PrivacyPolicy from '../../components/infoPages/privacyPolicy'

const PrivacyPage = ({authUser}) => {
  return (
    <div>
        <PrivacyPolicy authUser={authUser} />
    </div>
  )
}

export default PrivacyPage